// src/data/mockSubjects.js
export const mockSubjects = [
  {
    id: "SUBJ-001",
    code: "ENG7",
    name: "English 7",
    gradeLevel: "Grade 7",
    strand: "",
    teacher: "Mrs. Rivera",
    schedule: "Mon/Wed/Fri 8:00AM - 9:00AM",
    room: "Room 102",
  },
  {
    id: "SUBJ-002",
    code: "MATH7",
    name: "Mathematics 7",
    gradeLevel: "Grade 7",
    strand: "",
    teacher: "Mr. Dela Cruz",
    schedule: "Tue/Thu 9:00AM - 10:00AM",
    room: "Room 103",
  },
];
